<template>
  <div class="process_form">
    <el-main>
      <section class="section">
        <h2 class="title">Update Your 2023 Car Insurance</h2>
        <div class="cart">
          <h3 class="title">Your Progress</h3>
          <span class="num">{{ percentage }}%</span>
          <el-progress :percentage="percentage" :stroke-width="15" :show-text="false"
            define-back-color="rgba(222, 222, 222, 1)" color="rgba(82, 178, 222, 1)"></el-progress>
          <div v-if="from.nowcard == 1">
            <p class="tips">Select Vehicle Year</p>
            <div class="btn-group">
              <el-button :class="from.caryear == (2024 - i) ? 'btn active' : 'btn'" v-for="(i, index) in 40"
                :id="car_yaer_id + index" :key="i" @click="caryear(2024 - i)">{{ 2024 - i }}</el-button>
              <p class="clearflex"></p>
            </div>
          </div>
          <div v-if="from.nowcard == 2">
            <p class="tips">Select Vehicle Make</p>
            <div class="btn-group">
              <el-button :class="from.carmake == Object.keys(i)[0] ? 'btn active w145' : 'btn w145'"
                v-for="(i, index) in radiomakeoption" :key="Object.keys(i)[0]" :id="car_make_id + index"
                @click.native="clickcarmake(Object.keys(i)[0])">{{ Object.keys(i)[0] }}</el-button>
            </div>
            <div class="row">
              <el-select id="car_make_input_0" name="car_make" class="input_txt car_make" v-model="from.carmake"
                placeholder="Select Other Make" @change="clickcarmake" filterable>
                <el-option :value="''">Select Other Make</el-option>
                <el-option v-for="i in selectradiomakeoption" :key="Object.keys(i)[0]" :value="Object.keys(i)[0]">{{
                  Object.keys(i)[0] }}</el-option>
              </el-select>
            </div>
          </div>
          <div v-if="from.nowcard == 3">
            <p class="tips">Select Vehicle Model</p>
            <div class="row">
              <el-autocomplete id="car_model_input_0" name="input_txt car_model" class="car_model" v-model="from.carmodel"
                placeholder="Search" popper-class="popperclass" :fetch-suggestions="querySearch" :debounce="1000">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-autocomplete>
            </div>
            <div class="btn-group">
              <el-button :class="from.carmodel == i.name ? 'btn active w145' : 'btn w145'"
                v-for="(i, index) in carmodeloption" :key="i.code" :id="car_model_id + index"
                @click.native="moelclick(i.name)">{{ i.name }}</el-button>
              <p class="clearflex"></p>
            </div>
          </div>
          <div v-if="from.nowcard == 4">
            <p class="tips">Add Second Vehicle? (Save up to 25%)</p>
            <div class="checked">
              <el-button :class="issecondcard == true ? 'checked_btn active' : 'checked_btn'"
                @click.native="isaddsecond(true)">YES</el-button>
              <el-button :class="issecondcard == false ? 'checked_btn active' : 'checked_btn'"
                @click.native="isaddsecond(false)">NO</el-button>
            </div>
          </div>
          <div v-if="from.nowcard == 5">
            <p class="tips">Are You Currently Insured?</p>
            <div class="checked">
              <el-button :class="this.from.iscurrentlyinsured == true ? 'checked_btn active' : 'checked_btn'"
                @click.native="iscurrentlyinsured(true)">YES</el-button>
              <el-button :class="this.from.iscurrentlyinsured == false ? 'checked_btn active' : 'checked_btn'"
                @click.native="iscurrentlyinsured(false)">NO</el-button>
            </div>
          </div>
          <div v-if="from.nowcard == 6">
            <p class="tips">What Company are You Insured With?</p>
            <div class="btn-group">
              <el-button :class="from.company == i ? 'btn active w145' : 'btn w145'" :id="what_company + index"
                v-for="(i, index) in companyoption" :key="i" @click.native="whatcompany(i)">{{ i }}</el-button>
              <p class="clearflex"></p>
            </div>
          </div>
          <div v-if="from.nowcard == 7">
            <p class="tips">How Long Have You Been with {{ from.company }}?</p>
            <div class="btn-group">
              <el-button :class="from.howlong == i ? 'btn active w145' : 'btn w145'" :id="what_company + index"
                v-for="(i, index) in howlongOption" :key="i.value" @click.native="howlong(i.value)">{{ i.name
                }}</el-button>
              <p class="clearflex"></p>
            </div>
          </div>

          <div v-if="from.nowcard == 8">
            <p class="tips">Are You a Home Owner?</p>
            <div class="checked">
              <el-button :class="this.from.ishomeowner == true ? 'checked_btn active' : 'checked_btn'"
                @click.native="ishomeowner(true)">YES</el-button>
              <el-button :class="this.from.ishomeowner == false ? 'checked_btn active' : 'checked_btn'"
                @click.native="ishomeowner(false)">NO</el-button>
            </div>
          </div>
          <div v-if="from.nowcard == 9">
            <p class="tips">What Month is Your Birthday?</p>
            <div class="btn-group">
              <el-button :class="from.birthday == i ? 'btn active w100' : 'btn w100'" v-for="(i, index) in Birthdayoption"
                :key="i" @click.native="birthday(i)" :id="birthday_month_id + index">{{ i }}</el-button>
              <p class="clearflex"></p>
            </div>
          </div>
          <div v-if="from.nowcard == 10">
            <p class="tips">What Year Were You Born?</p>
            <div>
              <el-input name="born_input" style="margin-bottom:20px;" class="input_txt yearinput" id="born_input_0"
                v-model="from.birthyear" placeholder="YYYY" maxlength="4" oninput="value = value.replace(/[^\d]/g,'')"
                :class="{ 'errorinput': istrueyear }"></el-input>
              <div class="errortext" v-if="istrueyear">Please enter a valid date</div>
            </div>
            <el-button class="next_btn" style="background:rgb(28, 56, 136);color: rgba(255, 255, 255, 1);width: 150px;"
              @click.native="yearcontinue">
              <span>Continue</span>
            </el-button>
          </div>
          <div v-if="from.nowcard == 11">
            <p class="tips">Are You Married?</p>
            <div class="checked">
              <el-button :class="this.from.married == 'Male' ? 'checked_btn active' : 'checked_btn'"
                @click.native="isMarried('Male')">YES</el-button>
              <el-button :class="this.from.married == 'Female' ? 'checked_btn active' : 'checked_btn'"
                @click.native="isMarried('Female')">NO</el-button>
            </div>
          </div>
          <div v-if="from.nowcard == 12">
            <p class="tips">Any at-fault Accidents in the Last 3 years?</p>
            <div class="checked">
              <el-button :class="this.from.Accidents == 'Yes' ? 'checked_btn active' : 'checked_btn'"
                @click.native="isAccidents('Yes')">YES</el-button>
              <el-button :class="this.from.Accidents == 'No' ? 'checked_btn active' : 'checked_btn'"
                @click.native="isAccidents('No')">NO</el-button>
            </div>
          </div>
          <div v-if="from.nowcard == 13">
            <p class="tips">DUI in the Last 3 years?</p>
            <div class="checked">
              <el-button :class="this.from.DUI == 'Yes' ? 'checked_btn active' : 'checked_btn'"
                @click.native="isDUI('Yes')">YES</el-button>
              <el-button :class="this.from.DUI == 'No' ? 'checked_btn active' : 'checked_btn'"
                @click.native="isDUI('No')">NO</el-button>
            </div>
          </div>
          <div v-if="from.nowcard == 14">
            <p class="tips">What is Your Name?</p>
            <div>
              <el-input name="fiest_name" id="fiest_name" class="input_txt carmakestyle" placeholder="First Name"
                v-model="from.firstname" oninput="value = value.charAt(0).toUpperCase() + value.slice(1)"
                :class="{ 'errorinput': isfirstname }" maxlength="20"></el-input>
              <div class="errortext" v-if="isfirstname">Please enter First Name</div>
            </div>
            <div style="margin-top:10px">
              <el-input name="last_name" id="last_name" class="input_txt carmakestyle" placeholder="Last Name"
                v-model="from.lastname" oninput="value = value.charAt(0).toUpperCase() + value.slice(1)"
                :class="{ 'errorinput': islasename }" maxlength="20"></el-input>
              <div class="errortext" v-if="islasename">Please enter Last Name</div>
            </div>
            <el-button class="next_btn" style="background:rgb(28, 56, 136);color: rgba(255, 255, 255, 1);margin-top:30px;"
              @click.native="whatname()">Continue</el-button>
          </div>
          <div v-if="from.nowcard == 15">
            <p class="tips">Have You or Anyone in Your Family Served in the Military?</p>
            <div class="checked">
              <el-button :class="this.from.Military == true ? 'checked_btn active' : 'checked_btn'"
                @click.native="isMilitary(true)">YES</el-button>
              <el-button :class="this.from.Military == false ? 'checked_btn active' : 'checked_btn'"
                @click.native="isMilitary(false)">NO</el-button>
            </div>
          </div>
          <div v-if="from.nowcard == 16">
            <p class="tips">What is Your Address?</p>
            <el-row class="optiongroup">
              <el-col :xs="23" :sm="18" class="addressinputright">
                <el-autocomplete name="Address" id="Address_0" class="input_txt carmakestyle" placeholder="Address"
                  v-model="from.Address" :class="{ 'errorinput': isAddress }" :fetch-suggestions="autocompleteSearch"
                  ref="autocomplete" @select="handleSelect"></el-autocomplete>
                <div class="errortext" v-if="isAddress">Address is required</div>
              </el-col>
              <el-col :xs="23" :sm="6" class="addressinputleft">
                <el-input name="Unit" id="Unit_0" class="input_txt carmakestyle" placeholder="Unit#"
                  v-model="from.Unit"></el-input>
              </el-col>
              <el-col :xs="23" :sm="24" class="addressinput mobaddressinputleft">
                <el-input name="City" id="City_0" class=" input_txt carmakestyle" placeholder="City" v-model="from.City"
                  :class="{ 'errorinput': isCity }"></el-input>
                <div class="errortext" v-if="isCity">City is required</div>
              </el-col>
              <el-col :xs="12" :sm="12" class="addressinputright">
                <el-select name="Make" id="Make_0" v-model="from.State" placeholder="Select Other Make"
                  class="input_txt carmakestyle" filterable>
                  <el-option :value="''">Select Other Make</el-option>
                  <el-option v-for="i in us_state_map" :key="i" :value="i">{{ i }}</el-option>
                </el-select>
              </el-col>
              <el-col :xs="11" :sm="12" class="addressinputleft">
                <el-input name="Zip" id="Zip_0" class="input_txt carmakestyle" placeholder="Zip" v-model="from.Zip"
                  :class="{ 'errorinput': isZip }" maxlength="5" oninput="value = value.replace(/[^\d]/g,'')"></el-input>
                <div class="errortext" v-if="isZip">Please enter a valid Zip</div>
              </el-col>
            </el-row>
            <el-button class="next_btn md20"
              style="background:rgb(28, 56, 136);color: rgba(255, 255, 255, 1);margin-top:30px;"
              @click.native="addaddress">Continue</el-button>
          </div>
          <div v-if="from.nowcard == 17">
            <p class="tips">What is Your Email?</p>
            <div>
              <el-input name="email" id="email_0" class="input_txt carmakestyle" placeholder="Email" v-model="from.Email"
                :class="{ 'errorinput': isEmail }"></el-input>
              <div class="errortext" v-if="isEmail">Please enter a valid email address</div>
            </div>
            <div v-loading="emailloading" style="width: 130px;height: 46px;margin:0px auto;margin-top:30px">
              <el-button class="next_btn" style="background:rgb(28, 56, 136);color: rgba(255, 255, 255, 1);"
                @click.native="clickEmail">
                <span>Continue</span>
              </el-button>
            </div>
          </div>
          <div v-if="from.nowcard == 18">
            <!-- <p>Last Step, Lliu.</p>
            <p>Rates for your 2022 Ford Ecosport are Ready!</p> -->
            <p class="tips">What is Your Phone Number?</p>
            <div>
              <el-input v-model="from.phoneNum" :class="{ 'errorinput': isphoneNum }" name="Number" id="Number_0"
                placeholder="Phone Number" maxlength="11" class="input_txt phone_txt"
                oninput="value = value.replace(/[^\d]/g,'')" @change="formatPhoneNumber($event)"></el-input>
              <div class="errortext" v-if="isphoneNum">Please enter a valid Phone number</div>
            </div>
            <div v-loading="numloading" style="width: 150px;height: 46px;margin:0px auto;margin-top:30px">
              <el-button class="next_btn" style="background:rgb(28, 56, 136);color: rgba(255, 255, 255, 1);width: 150px;"
                @click.native="fromcontinue">
                <span>Continue</span>
              </el-button>
            </div>
          </div>
          <div class="error">
            <div class="error_inner" v-if="from.nowcard != 18">
              <i class="el-icon-check fsize20"></i> You could save up to <strong>25%</strong> by insuring multiple
              vehicles
            </div>
            <div class="error_inner" v-else>
              <i class="el-icon-check fsize20"></i> Your car quotes are ready
            </div>
          </div>
          <span class="back-icon" @click="back">
            <img src="@/assets/imgs/back.webp" />
          </span>
        </div>
        <div class="content" v-if="from.nowcard == 18">
          <p>By clicking the "Get Quote" button, I provide my electronic signature and represent that I am at least 18 and
            agree to this website's <a href="/privacy-statement">Privacy Policy</a> and <a href="/terms-of-use">Terms of
              Use</a>.</p>
          <p>By clicking the "Get Quote" button, I provide my express written consent and authorization to the owner of
            this website and/or the agents of one or more of the listed businesses to contact me for
            marketing/telemarketing purposes at the number and address provided above, including my wireless number if
            provided, using live operators, automated telephone dialing systems, artificial voice or pre-recorded
            messages, text messages and/or emails, if applicable, even if I have previously registered the provided number
            on any Federal or State Do Not Call Registry. I understand that my consent is not required as a condition of
            purchasing goods or services and can be revoked at any time.</p>
          <p>Message and data rates may apply. Message frequency varies. Reply HELP for customer support or STOP to
            opt-out. See <a href="/terms-of-service">SMS Terms of Service</a> for more details.</p>
        </div>
      </section>

      <div class="recommend">
        <div class="zanzhu">
          <img alt="wellcare" src="@/assets/imgs/geico.png" />
          <img alt="Aetna" src="@/assets/imgs/century.png" />
          <img alt="blue" src="@/assets/imgs/progressive.png" />
          <img alt="cigama" src="@/assets/imgs/allstate.png" />
          <img alt="CVS_Health_logo" src="@/assets/imgs/libcrty-mutual.png" />
          <img alt="h" src="@/assets/imgs/nationwide.png" />
          <img alt="kalser" src="@/assets/imgs/travelers.png" />
        </div>
      </div>
      <div class="trademark">
        <img src="@/assets/imgs/trademark_1.png" />
        <img src="@/assets/imgs/trademark_2.png" />
        <img src="@/assets/imgs/trademark_3.png" />
      </div>
      <el-dialog :visible.sync="dialogVisible" width="40%" :show-close="false" :before-close="handleClose">
        <div class="dialog_inner">
          <div class="header">
            Wait! View quotes online now.
            <i class="el-icon-circle-close close-icon" @click="handleClose"></i>
          </div>
          <div class="centont">
            <p class="tips">Click to get the best rate.</p>
            <div class="list">
              <div class="item">
                <div class="row">
                  <div class="lf">
                    <img src="@/assets/imgs/coverage-professor.svg" />
                  </div>
                  <div class="rg">
                    <el-button class="link-btn"
                      @click="toLink('https://pentlyconger.com/b684e266-05ff-4571-ae3b-7eaa11bdcc33')"> View My Quote
                    </el-button>
                  </div>
                </div>
                <p class="txt" @click="toLink('https://pentlyconger.com/b684e266-05ff-4571-ae3b-7eaa11bdcc33')">Affordable
                  Car Insurance Quotes</p>
              </div>
              <div class="item">
                <div class="row">
                  <div class="lf">
                    <img
                      src="data:image/png;base64,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" />
                  </div>
                  <div class="rg">
                    <el-button class="link-btn"
                      @click="toLink('https://pentlyconger.com/1ecf0f4f-83a2-4257-b535-77ee7cdd3f99')">View My Quote
                    </el-button>
                  </div>
                </div>
                <p class="txt" @click="toLink('https://pentlyconger.com/1ecf0f4f-83a2-4257-b535-77ee7cdd3f99')">Seeking
                  the Perfect car Insurance?</p>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </el-main>
  </div>
</template>

<script>
// import '@/assets/js/loadJs'
import { ContactUsFrom, VFun, UpUsFrom } from '@/api/index'
import { Encrypt, Decrypt, deepCopy } from '@/plugins/jessas'
import { Select, Option, Loading, Input, Row, Col, Autocomplete, Dialog } from "element-ui";
Vue.use(Select);
Vue.use(Option);
Vue.use(Autocomplete);
Vue.use(Dialog);
Vue.use(Loading.directive);
Vue.use(Row);
Vue.use(Col);
Vue.use(Input);

Vue.prototype.$loading = Loading.service;
export default {
  name: 'ProcessFormDetails',
  data() {
    return {
      MyAdd: '',
      percentage: 15,
      from: {
        caryear: '',
        carmake: '',
        carmodel: '',
        cards: [],
        iscurrentlyinsured: '',
        company: '',
        howlong: false,
        ishomeowner: false,
        birthday: '',
        birthyear: '',
        married: '',
        Accidents: false,
        DUI: false,
        firstname: '',
        lastname: '',
        Military: '',
        Address: '',
        Unit: '',
        City: '',
        State: 'Alabama',
        Zip: '',
        Email: '',
        phoneNum: '',
        nowcard: 1
      },
      radiomakeoption: [],
      selectradiomakeoption: [],
      carmakeJson: {},
      carmodeloption: [],
      recarmodeloption: [],
      companyoption: [' 21st Century Insurance ', ' AAA Insurance Co. ', ' Allstate ', ' American Family ', ' AMICA ', ' Country Financial ', ' Esurance ', ' Farmers ', ' Geico ', ' Liberty Mutual ', ' Mercury ', ' Metlife ', ' Nationwide ', ' Progressive ', ' Safeco ', ' State Farm ', ' The Hartford ', ' Travelers ', ' USAA ', ' Other '],
      Birthdayoption: [' Jan ', ' Feb ', ' Mar ', ' Apr ', ' May ', ' Jun ', ' July ', ' Aug ', ' Sept ', ' Oct ', ' Nov ', ' Dec '],
      us_state_map: { AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California', CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', DC: 'District Of Columbia', FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jeresy', NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'Southcarolina', SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming' },
      istrueyear: false,
      isAddress: false,
      isCity: false,
      isZip: false,
      inputerror: false,
      isEmail: false,
      isphoneNum: false,
      isloading: true,
      numistrue: false,
      issecondcard: false,
      isfirstname: false,
      islasename: false,
      showgs: false,
      emailloading: false,
      numloading: false,
      renum: '',
      predictions: [],
      car_yaer_id: 'car_yaer_',
      car_make_id: 'car_make_',
      car_model_id: 'car_model_',
      what_company: 'car_model_',
      birthday_month_id: 'birthday_month_',
      useruuid: '',
      dialogVisible: false,
      timer: null,
      howlongOption: [
        { name: '1-2 years', value: '1-2' },
        { name: '2-3 years', value: '2-3' },
        { name: '3-5 years', value: '3-5' },
        { name: '5+ years', value: '5+' },
        { name: 'Less than a year', value: 'Less than a year' }
      ]
    }
  },
  async created() {
    window.localStorage.setItem('lastTime', new Date().getTime())
    window.document.onmousedown = function () {
      window.localStorage.setItem('lastTime', new Date().getTime())
    }
    this.timer = window.setInterval(() => this.checkTimeout(), 10000);
    await this.loadJS('https://maps.googleapis.com/maps/api/js?key=AIzaSyBrT81D9HC8RoGtRpyxJn2veqlEbrYw0yE&libraries=places')
    await this.loadJS('/js/loadJs.js');
  },
  mounted() {
    this.MyAdd = this.$route.params.Myadd
    this.from.State = this.MyAdd
    this.isfrom()
    this.generateUniqueId()
    this.radiomakeoption = localStorage.getItem('radiomakeoption') ? JSON.parse(localStorage.getItem('radiomakeoption')) : []
    this.selectradiomakeoption = localStorage.getItem('selectradiomakeoption') ? JSON.parse(localStorage.getItem('selectradiomakeoption')) : []
    this.carmodeloption = localStorage.getItem('carmodeloption') ? JSON.parse(localStorage.getItem('carmodeloption')) : []
    this.recarmodeloption = localStorage.getItem('carmodeloption') ? JSON.parse(localStorage.getItem('carmodeloption')) : []
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    checkTimeout() {
      //更新当前时间
      let currentTime = new Date().getTime()
      let lastTime = window.localStorage.getItem("lastTime");
      //判断是否超时
      if (currentTime - lastTime > (30 * 1000)) {
        let isShow = window.localStorage.getItem("isShow");
        if (!isShow) {
          this.dialogVisible = true;
          window.localStorage.setItem("isShow", 1);
        }
        if (this.timer) {
          window.clearInterval(this.timer);
        }
      }
    },
    loadJS(url) {
      return new Promise((resolve) => {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        // IE
        if (script.readyState) {
          script.onreadystatechange = () => {
            if (script.readyState == 'loaded'
              || script.readyState == 'complete') {
              script.onreadystatechange = null;
              resolve();
            }
          };
        } else {
          // 其他浏览器
          script.onload = function () {
            resolve();
          };
        }
        document.getElementsByTagName('head')[0].appendChild(script);
      })
    },
    isfrom() {
      if (!localStorage.getItem('cardfrom') || !localStorage.getItem('percentage')) {
        localStorage.setItem('cardfrom', JSON.stringify(this.from))
        localStorage.setItem('percentage', this.percentage)
      } else {
        this.from = JSON.parse(localStorage.getItem('cardfrom'))
        this.percentage = localStorage.getItem('percentage') - 0
        console.log(this.from)
      }
    },
    format(percentage) {
      return `${percentage}%` + '\n' + 'Complete'
    },
    async caryear(caryear) {
      if (this.issecondcard) {
        this.from.cards[1].caryear = caryear
      }
      this.radiomakeoption = []
      this.selectradiomakeoption = []
      this.from.caryear = caryear.toString()
      // this.carmakeJson = require(`../plugins/${caryear}.json`);
      this.carmakeJson = await import(`../plugins/${this.from.caryear}.json`)
      this.carmodeloption = this.carmakeJson[caryear]
      this.radiomakeoption = this.carmakeJson[caryear].slice(0, 12)
      this.selectradiomakeoption = this.carmakeJson[caryear].slice(12)
      localStorage.setItem('radiomakeoption', JSON.stringify(this.radiomakeoption))
      localStorage.setItem('selectradiomakeoption', JSON.stringify(this.selectradiomakeoption))
      this.nest()
    },
    async clickcarmake(carmake) {
      if (this.issecondcard) {
        this.from.cards[1].carmake = carmake
      }
      this.carmodeloption = []
      this.from.carmake = carmake
      // this.carmakeJson = require(`../plugins/${this.from.caryear}.json`);
      this.carmakeJson = await import(`../plugins/${this.from.caryear}.json`)
      this.carmakeJson[this.from.caryear].forEach(e => {
        if (e[carmake]) {
          this.carmodeloption = e[carmake]
        }
      })
      console.log(this.carmodeloption)
      localStorage.setItem('carmodeloption', JSON.stringify(this.carmodeloption))
      this.recarmodeloption = deepCopy(this.carmodeloption)
      this.nest()
    },
    moelclick(carmodel) {
      if (this.issecondcard) {
        this.from.cards[1].carmodel = carmodel
        this.from.nowcard = 5
        return
      }
      this.from.carmodel = carmodel
      this.nest()
    },
    isaddsecond(issecond) {
      if (issecond) {
        this.issecondcard = true
        this.from.cards.push({ caryear: this.from.caryear, carmake: this.from.carmake, carmodel: this.from.carmodel }, { caryear: '', carmake: '', carmodel: '' })
        this.from.nowcard = 1
      } else {
        this.issecondcard = false
        this.nest()
      }
    },
    iscurrentlyinsured(iscurrentlyinsured) {
      this.from.iscurrentlyinsured = iscurrentlyinsured
      if (iscurrentlyinsured) {
        this.nest()
      } else {
        this.from.nowcard = 8
        this.percentage = this.percentage + 5
      }
    },
    whatcompany(company) {
      this.from.company = company
      this.nest()
    },
    howlong(time) {
      this.from.howlong = time
      this.nest()
    },
    ishomeowner(ishomeowner) {
      this.from.ishomeowner = ishomeowner
      this.nest()
    },
    birthday(birthday) {
      this.from.birthday = birthday
      this.nest()
    },
    querySearch(queryString, cb) {
      // var carmodeloption = this.carmodeloption;
      console.log(queryString)
      var carmodeloption = JSON.parse(JSON.stringify(this.recarmodeloption))
      this.carmodeloption = queryString ? carmodeloption.filter(this.createFilter(queryString)) : this.recarmodeloption
      console.log(this.recarmodeloption)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.name.toLowerCase().includes(queryString.toLowerCase()))
      }
    },
    yearcontinue() {
      var myDate = new Date()
      var age = myDate.getFullYear() - this.from.birthyear
      if (age < 16 || age > 80) {
        this.istrueyear = true
        this.inputerror = true
      } else {
        this.istrueyear = false
        this.inputerror = false
        this.nest()
      }
    },
    isMarried(Married) {
      this.from.married = Married
      this.nest()
    },
    isAccidents(isAccidents) {
      this.from.Accidents = isAccidents
      this.nest()
    },
    isDUI(isDUI) {
      this.from.DUI = isDUI
      this.nest()
    },
    whatname() {
      if (!this.from.firstname && !this.from.lastname) {
        this.isfirstname = true
        this.islasename = true
      } else if (!this.from.firstname) {
        this.isfirstname = true
      } else if (!this.from.lastname) {
        this.islasename = true
      } else {
        this.isfirstname = false
        this.islasename = false
        this.nest()
      }
    },
    isMilitary(isMilitary) {
      this.from.Military = isMilitary
      this.nest()
    },
    addaddress() {
      const card12 = [!this.from.Address, !this.from.City, !this.from.Zip, this.from.Zip.length != 5]
      if (card12.indexOf(true) === -1) {
        this.isAddress = false
        this.isCity = false
        this.isZip = false
        this.nest()
      } else {
        this.from.Address ? this.isAddress = false : this.isAddress = true
        this.from.City ? this.isCity = false : this.isCity = true
        this.from.Zip ? this.isZip = false : this.isZip = true
        this.from.Zip.length != 5 ? this.isZip = true : this.isZip = false
      }
    },
    async clickEmail() {
      console.log(Encrypt(this.from.Email + ',2841e22ed3754f98aa7c36d7a3848ec1,email,dsfsdf'))
      if (this.emailloading) {
        return
      }
      const chexkemail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      if (!this.from.Email || !chexkemail.test(this.from.Email)) {
        this.isEmail = true
      } else {
        this.emailloading = true
        const res = await VFun({ data: Encrypt(this.from.Email + ',2841e22ed3754f98aa7c36d7a3848ec1,email,dsfsdf') })
        if (Decrypt(res).split(',')[1] === 'False') {
          this.isEmail = true
          this.emailloading = false
        } else {
          this.isEmail = false
          this.emailloading = false
          this.nest()
        }
      }
    },
    formatPhoneNumber(phoneNumberString) {
      this.renum = phoneNumberString
      var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
      var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
      // if (!this.from.phoneNum || this.from.phoneNum.length < 10) {
      // 	this.isphoneNum = true
      // 	this.numistrue = false
      // } else if (match) {
      // 	const res = await VerifyPhoneApi(this.from.phoneNum)
      // 	if (res.valid) {
      // 		this.isphoneNum = false
      // 		var intlCode = (match[1] ? '+1 ' : '');
      // 		this.from.phoneNum =  [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
      // 		this.numistrue = true
      // 	} else {
      // 		this.isphoneNum = true
      // 		this.numistrue = false
      // 	}
      // }
      if (!this.from.phoneNum || this.from.phoneNum.length < 10) {
        this.isphoneNum = true
        this.numistrue = false
      } else if (match) {
        this.isphoneNum = false
        var intlCode = (match[1] ? '+1 ' : '')
        this.from.phoneNum = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
        console.log(intlCode)
        this.numistrue = true
      }
    },
    async fromcontinue() {
      this.numloading = true
      console.log(this.renum)
      const res = await VFun({ data: Encrypt(this.renum + ',2841e22ed3754f98aa7c36d7a3848ec1,phone,dsfsdf') })
      if (Decrypt(res).split(',')[1] === 'True') {
        this.isphoneNum = false
        this.numistrue = true
        this.numloading = false
        let subfrom = JSON.parse(localStorage.getItem('usercardfrom'))
        if (!subfrom) {
          subfrom = {}
        }
        subfrom.name = this.from.firstname + ' ' + this.from.lastname
        subfrom.phone = this.from.phoneNum
        subfrom.other = this.from
        subfrom.other.date = new Date().toLocaleString()
        if (this.numistrue) {
          UpUsFrom(subfrom)
          this.isloading = false
          const loading = this.$loading({
            lock: true,
            text: '',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          let _this = this;
          window.setTimeout(() => {
            loading.close();
            _this.$router.push({ path: "/Result" }).catch(() => { });
          }, 2000)
        }
      } else {
        this.isphoneNum = true
        this.numistrue = false
        this.numloading = false
      }
    },
    back() {
      if (this.from.nowcard === 1) {
        this.$router.go(-1)
        return
      }
      if (this.from.nowcard === 1 && this.issecondcard) {
        this.from.nowcard = 4
        this.percentage = this.percentage - 5
        localStorage.setItem('cardfrom', JSON.stringify(this.from))
        localStorage.setItem('percentage', this.percentage)
        return
      }
      if (this.from.nowcard === 8 && !this.from.iscurrentlyinsured) {
        this.from.nowcard = 5
        this.percentage = this.percentage - 5
        localStorage.setItem('cardfrom', JSON.stringify(this.from))
        localStorage.setItem('percentage', this.percentage)
        return
      }
      this.from.nowcard--
      this.percentage = this.percentage - 5
      localStorage.setItem('cardfrom', JSON.stringify(this.from))
      localStorage.setItem('percentage', this.percentage)
    },
    nest() {
      this.from.nowcard++
      if (this.percentage !== 100) {
        this.percentage = this.percentage + 5
      }
      localStorage.setItem('cardfrom', JSON.stringify(this.from))
      localStorage.setItem('percentage', this.percentage)
      this.upuserdata()
    },
    autocompleteSearch(queryString, cb) {
      if (!queryString) {
        this.predictions = []
        return
      }
      const autocompleteService = new google.maps.places.AutocompleteService()
      autocompleteService.getPlacePredictions({ input: queryString, componentRestrictions: { country: 'US' } }, (predictions) => {
        predictions.forEach(e => {
          this.predictions.push({
            value: e.description
          })
        })
        cb(this.predictions)
        // this.predictions = predictions || [];
        // cb(predictions.map((prediction) => prediction.description));
      })
    },
    handleSelect(item) {
      const geocoder = new google.maps.Geocoder()
      geocoder.geocode({ address: item.value }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results[0]) {
          const address = results[0]
          const streetNumber = address.address_components.find(component =>
            component.types.includes('street_number')
          )
          const route = address.address_components.find(component =>
            component.types.includes('route')
          )
          const locality = address.address_components.find(component =>
            component.types.includes('locality')
          )
          const administrativeArea = address.address_components.find(component =>
            component.types.includes('administrative_area_level_1')
          )
          const postalCode = address.address_components.find(component =>
            component.types.includes('postal_code')
          )

          this.from.Address = `${streetNumber && streetNumber.long_name} ${route && route.long_name
            }`
          this.from.City = locality && locality.long_name
          this.from.State = administrativeArea && administrativeArea.short_name
          this.from.Zip = postalCode && postalCode.long_name
        }
      })
    },
    generateUniqueId() {
      if (!localStorage.getItem('useruuid')) {
        const timestamp = new Date().getTime()
        const random = Math.random().toString(36).substring(2, 10)
        this.useruuid = timestamp.toString(36) + random
        localStorage.setItem('useruuid', this.useruuid)
        this.Initializedata()
      } else {
        this.useruuid = localStorage.getItem('useruuid', this.useruuid)
      }
    },
    // 进入表单发送生成请求
    async Initializedata() {
      const subfrom = {}
      const userip = JSON.parse(localStorage.getItem('userip'))
      subfrom.other = this.from
      subfrom.web_id = 43
      subfrom.category_id = 164
      subfrom.other.date = new Date().toLocaleString()
      subfrom.other.ip = userip.ip
      subfrom.other.ipcity = userip.city
      subfrom.other.leadid = leadid
      subfrom.other.timezone = userip.timezone
      subfrom.name = this.useruuid ? this.useruuid : localStorage.setItem('useruuid', this.useruuid)
      subfrom.other.useruuid = this.useruuid ? this.useruuid : localStorage.setItem('useruuid', this.useruuid)
      const res = await ContactUsFrom(subfrom)
      localStorage.setItem('usercardfrom', JSON.stringify(res))
    },
    // 更新表单数据
    async upuserdata() {
      let subfrom = JSON.parse(localStorage.getItem('usercardfrom'))
      if (!subfrom) {
        subfrom = {
          other: {
            date: new Date().toLocaleString()
          }
        }
      }
      subfrom.other = this.from
      subfrom.other.date = new Date().toLocaleString()
      subfrom.web_id = 43
      subfrom.category_id = 164
      subfrom.other.leadid = leadid
      const res = await UpUsFrom(subfrom)
      localStorage.setItem('usercardfrom', JSON.stringify(res.data))
    },
    toLink(link) {
      window.open(link)
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/layout.scss";

.process_form {
  margin-top: 70px;

  .el-main {
    padding: 0px;
    overflow: hidden;
    background: rgb(246, 249, 254);

    .section {
      min-height: 650px;
      margin-bottom: 20px;

      .title {
        font-weight: 900;
        font-size: 35px;
        text-align: center;
        line-height: 4;
        color: rgba(28, 56, 136, 1);
        ;
      }

      .num {
        font-size: 20px;
        font-weight: 700;
        display: block;
        text-align: center;
        color: rgba(82, 178, 222, 1);
        margin: 0px auto 10px auto;
      }

      .cart {
        width: 35%;
        min-height: 350px;
        background: rgba(255, 255, 255, 1);
        border-radius: 15px;
        box-shadow: 0px 0px 19px rgb(145, 211, 255, 0.5);
        margin: 0px auto;
        padding: 30px 5% 60px 5%;
        text-align: center;
        position: relative;

        .title {
          color: #000;
          font-size: 20px;
          font-weight: 700;
          text-align: center;
          line-height: 2;
        }

        .tips {
          font-size: 28px;
          font-weight: 700;
          text-align: center;
          margin: 30px 20px 20px 20px;
        }

        .btn-group {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;

          .btn {
            float: left;
            padding: 15px 20px;
            color: rgba(28, 56, 136, 1);
            background: rgba(255, 255, 255, 1);
            margin: 0 7.5px 15px;
            border-radius: 5px;
            font-size: 24px;
            font-weight: 450;
            text-align: center;
            border: 1px solid rgba(82, 178, 222, 1);
            overflow: hidden;
          }

          .btn:hover,
          .btn.active {
            cursor: pointer;
            color: rgba(255, 255, 255, 1);
            background: rgba(100, 176, 212, 1);
            border: 1px solid rgba(82, 178, 222, 1);
          }

          .w100 {
            width: 100px;
          }

          .w145 {
            width: 46%;
            overflow: hidden;
          }

          .clearflex {
            width: 100%;
            clear: both;
            height: 10px;
          }
        }

        .row {
          width: 100%;

          .car_make {
            width: 97%;
            font-size: 24px;

            .el-input__inner {
              border: 1px solid rgba(82, 178, 222, 1);
            }
          }

          .car_model {
            width: 97%;
            font-size: 24px;
            margin-bottom: 20px;

            .el-input__inner {
              border: 1px solid rgba(82, 178, 222, 1);
            }
          }
        }

        .checked {
          padding: 25px 0px;

          .checked_btn {
            width: 106px;
            height: 50px;
            font-size: 16px;
            font-weight: 400;
            margin: 0px 20px;
            color: rgba(0, 0, 0, 0.3);
            border: 1px solid rgba(82, 178, 222, 1);
          }

          .checked_btn:hover,
          .checked_btn.active {
            background: rgba(82, 178, 222, 1);
            color: rgba(255, 255, 255, 1) !important;
          }
        }

        .next_btn {
          background: rgba(255, 150, 150, 1);
          color: rgba(255, 255, 255, 1);
          width: 128px;
          height: 46px;
          font-size: 20px;
          font-weight: 700;
        }

        .md20 {
          margin-bottom: 20px;
        }

        .optiongroup {
          margin-top: 10px;
          overflow: hidden;

          .addressinputright {
            padding-right: 15px;
            margin-bottom: 2rem;
          }

          .mobaddressinputleft {
            margin-bottom: 2rem;
            width: 100%;
          }

          .carmakestyle {
            width: 100%;
          }
        }

        .input_txt {
          .el-input__inner {
            border: 1px solid rgba(82, 178, 222, 1);
            font-size: 20px;
            height: 45px;
            line-height: 45px;
          }
        }

        .el-input {
          font-size: 20px;
        }

        .yearinput,
        .phone_txt {
          .el-input__inner {
            text-align: center;
          }
        }

        .error {
          margin-top: 20px;
          border-radius: 20px;
          border: 1px solid rgba(14, 50, 162, 1);

          .error_inner {
            border-radius: 20px;
            padding: 10px;
            margin: 2px;
            border: 1px solid rgba(14, 50, 162, 0.5);
            color: rgba(28, 56, 136, 1);
            font-size: 14px;
            font-weight: 500;
            overflow: hidden;

            .fsize20 {
              font-size: 20px;
            }
          }
        }

        .errorinput {
          .el-input__inner {
            border: 1px solid #eb737a;
          }
        }

        .errortext {
          color: #eb737a;
          padding: 0px;
          height: 25px;
          line-height: 25px;
          text-align: left;
          font-size: 14px;
        }
      }

      .content {
        width: 50%;
        margin: 40px auto 100px auto;
        border-radius: 25px;
        padding: 20px 3%;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 19px rgba(199, 199, 199, 0.4);

        p {
          color: rgba(108, 99, 100, 1);
          font-size: 14px;

          a {
            color: #2f9ee9;
          }
        }
      }

      .back-icon {
        position: absolute;
        top: 40px;
        left: 30px;
        cursor: pointer;
      }
    }

    .recommend {
      text-align: center;

      .r_content {
        font-size: 16px;
        color: rgba(28, 56, 136, 1);
        font-weight: 700;
        padding: 10px 0px;
      }

      .zanzhu {
        width: 100%;
        background: rgb(255, 255, 255);
        background-repeat: no-repeat;
        background-size: cover;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
        text-align: center;

        img {
          vertical-align: middle;
          margin: 20px 30px;
          width: 110px;
        }
      }
    }

    .trademark {
      text-align: center;
      margin: 30px 0px;

      img {
        padding: 50px;
      }
    }
  }

  .el-dialog {
    border-radius: 15px;
  }

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;

  }

  .dialog_inner {
    height: 450px;
    background: rgb(82, 178, 222);
    border-radius: 15px;

    .header {
      height: 55px;
      line-height: 55px;
      text-align: center;
      color: rgb(255, 255, 255);
      font-size: 20px;
      position: relative;

      .close-icon {
        position: absolute;
        right: 20px;
        top: 10px;
        cursor: pointer;
        font-size: 25px;
      }
    }

    .centont {
      margin: 20px;
      padding: 10px;
      background: rgba(255, 255, 255, 1);
      border-radius: 15px;

      .tips {
        margin-left: 10px;
        line-height: 2;
        color: rgba(69, 165, 241, 1);
      }

      .list {
        height: 300px;
        overflow-y: scroll;
        padding: 0px 10px;

        &::-webkit-scrollbar {
          width: 5px;
        }

        &::-webkit-scrollbar-track {
          background-color: #fff;
        }

        &::-webkit-scrollbar-thumb {
          background: rgb(82, 178, 222);
          border-radius: 15px;
          max-height: 45px;
        }

        .item {
          text-align: center;
          border: 1px solid rgb(82, 178, 222);
          margin-bottom: 20px;
          padding: 10px;
          border-radius: 15px;

          .row {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .lf {
              img {
                max-width: 90%;
              }
            }
          }

          .txt {
            margin-top: 10px;
            cursor: pointer;
          }

          .txt:hover {
            color: rgb(69, 165, 241);
          }

          .link-btn {
            background: rgb(82, 178, 222);
            color: rgb(255, 255, 255);
          }

          .link-btn:hover,
          .link-btn:active {
            background: rgb(0, 189, 189);
            color: rgb(255, 255, 255);
          }
        }
      }
    }
  }
}

.is-fullscreen .el-loading-spinner {
  background-image: url('../assets/loading.webp');
  background-repeat: no-repeat;
  background-size: 150px 150px;
  height: 150px;
  width: 100%;
  background-position: center;
  top: 40%;
  transform: rotate(0deg);
  animation: path 5s linear infinite;
}

@keyframes path {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.is-fullscreen .el-loading-spinner .el-icon-loading,
.is-fullscreen .el-loading-spinner .el-loading-text {
  display: none;
}

.el-loading-mask.is-fullscreen {
  background-color: transparent;
}

@media screen and (max-width:1300px) {
  .process_form {
    .el-main {
      .section {
        .cart {
          width: 50%;
          min-height: 330px;
        }
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .process_form {
    .el-main {
      .section {
        .title {
          font-size: 35px;
          margin-top: 20px;
        }

        .cart {
          width: calc(70% - 20px);
          margin: 20px auto;
          padding: 10px 10px 60px 10px;
          min-height: 380px;

          .optiongroup {
            .addressinputright {
              padding-right: 15px;
            }

            .addressinputleft {
              margin-bottom: 2rem;
            }

            .mobaddressinputleft {
              width: 100%;
            }

            .addressinputleft:last-child {
              padding-left: 15px;
            }
          }

          .back-icon {
            top: 38px;
          }

          .el-input {
            font-size: 18px;
          }

          .input_txt {
            .el-input__inner {
              font-size: 18px;
            }
          }

          .btn-group {
            .btn {
              font-size: 18px;
            }

            .w145 {
              font-size: 18px;
              width: 40%;
            }
          }
        }

        .content {
          width: 90%;
        }
      }

      .recommend {
        .zanzhu {
          background: rgba(255, 255, 255, 1);
        }
      }

      .trademark {
        img {
          padding-bottom: 10px;
        }
      }
    }

    .dialog_inner {
      height: 450px;
      background: rgb(82, 178, 222);
      border-radius: 15px;

      .header {
        height: 55px;
        line-height: 55px;
        text-align: center;
        color: rgb(255, 255, 255);
        font-size: 20px;
        position: relative;

        .close-icon {
          position: absolute;
          right: 20px;
          top: 10px;
          cursor: pointer;
          font-size: 25px;
        }
      }
    }
  }

  .el-dialog {
    width: 56% !important;

    .tips {
      color: rgba(69, 165, 241, 1);
    }
  }
}

@media screen and (max-width: 768px) {
  .process_form {
    margin-top: 76px;

    .el-main {
      .section {
        min-height: 600px;

        .title {
          font-size: 26px;
          line-height: 1;
        }

        .cart {
          width: calc(96% - 20px);
          margin: 20px auto;
          padding: 10px 10px 50px 10px;
          min-height: 370px;

          .optiongroup {
            .addressinputright {
              padding-right: 0px;
            }

            .addressinputleft {
              margin-bottom: 2rem;
            }

            .mobaddressinputleft {
              width: 95.55%;
            }

            .addressinputleft:last-child {
              padding-left: 15px;
            }
          }

          .back-icon {
            top: 38px;
          }

          .el-input {
            font-size: 16px;
          }

          .input_txt {
            .el-input__inner {
              font-size: 16px;
            }
          }

          .btn-group {
            .btn {
              font-size: 14px;
            }

            .w145 {
              font-size: 14px;
              width: 45%;
            }
          }
        }

        .content {
          width: 90%;
        }
      }

      .recommend {
        .zanzhu {
          background: rgba(255, 255, 255, 1);
        }
      }

      .trademark {
        img {
          padding-bottom: 10px;
        }
      }
    }

    .dialog_inner {
      height: 450px;
      background: rgb(82, 178, 222);
      ;
      border-radius: 15px;

      .header {
        height: 55px;
        line-height: 55px;
        text-align: center;
        color: rgb(255, 255, 255);
        font-size: 17px;
        position: relative;

        .close-icon {
          position: absolute;
          right: 10px;
          top: 10px;
          cursor: pointer;
          font-size: 25px;
        }
      }

      .centont {
        margin-top: 10px;

        .list .item {
          .link-btn {
            font-size: 12px;
          }
        }
      }
    }
  }

  .el-dialog {
    width: 96% !important;
  }
}

@media screen and (max-width: 516px) {
  .process_form {
    .dialog_inner {
      .centont {
        margin-top: 10px;

        .list .item {
          .row {
            flex-wrap: wrap;
            text-align: center;

            .lf,
            .rg {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
